import { ISubscriptionPriceChangesPopup } from 'shared/types/subscriptionPriceChangesPopup';

import { IState } from '../store';

export function subscriptionPriceChangesSelector(state: IState): ISubscriptionPriceChangesPopup {
  return state.subscriptionPriceChangesPopup;
}
